module.exports = __webpack_public_path__ + "img/img-icon.24da3332.svg";